<template>
  <div class="sidebar-left">
    <div class="logo">
      <router-link :to="{name: 'Home'}">
        <img src="/assets/images/logo.png" alt="Logo">
        <img src="/assets/images/logo-simple.png" alt="LogoSimple">
      </router-link>
    </div>
    <ul class="main-menu">
      <li>
        <router-link :to="{name: 'Dashboard'}" class="menu-item"><i class="el-icon-wallet"></i><span>{{ $t('MENU_DASHBOARD') }}</span></router-link>
      </li>
      <li>
        <router-link :to="{name: 'BuyPackage'}" class="menu-item"><i class="el-icon-coin"></i><span>{{ $t('MENU_BUY_PACKAGE') }}</span></router-link>
      </li>
      <li>
        <router-link :to="{name: 'Commission'}" class="menu-item"><i class="el-icon-present"></i><span>{{ $t('MENU_COMMISSION') }}</span></router-link>
      </li>
      <li>
        <router-link :to="{name: 'OrganizationChart'}" class="menu-item"><i class="el-icon-pie-chart"></i><span>{{ $t('MENU_ORGANIZATION_CHART') }}</span></router-link>
      </li>
      <li>
        <router-link :to="{name: 'affiliate'}" class="menu-item"><i class="el-icon-medal"></i><span>{{ $t('MENU_AFFILIATE') }}</span></router-link>
      </li>
      <li>
        <router-link :to="{name: 'profile'}" class="menu-item"><i class="el-icon-user"></i><span>{{ $t('MENU_PROFILE') }}</span></router-link>
      </li>
      <li>
        <a class="menu-item menu-logout" @click.prevent="logout()"><i class="el-icon-switch-button"></i><span>{{ $t('MENU_LOGOUT') }}</span></a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isCollapsedMenu: false
    }
  },
  methods: {
    logout () {
      this.$confirm('Logout', this.$t('TEXT_CONFIRM'), {
        confirmButtonText: this.$t('BTN_OK'),
        cancelButtonText: this.$t('BTN_CANCEL'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout')
      }).catch(() => {
      })
    }
  }
}
</script>
